import './Language.css';
// Redux
import { useDispatch, useSelector } from 'react-redux';

import { useLocation } from 'react-router-dom';
import i18n from '../../i18n';
import { setLanguageInstitution } from '../../app/features/institutionSlice';
import { PiLineVertical } from 'react-icons/pi';

const Language = () => {
  const location = useLocation();
  const dispatch = useDispatch();

  const { languageInstitution } = useSelector((state) => state.institution);

  const changeLanguage = (language) => {
    dispatch(setLanguageInstitution(language));
    i18n.changeLanguage(language);
  };

  const getClass = (mode) => {
    let name = languageInstitution === mode ? 'active' : '';
    if (location.pathname === '/') {
      name += ' home';
    }
    return name.trim();
  };

  return (
    <div className='language'>
      <button className={getClass('en')} onClick={() => changeLanguage('en')}>
        EN
      </button>
      <PiLineVertical className={location.pathname === '/' ? 'home': ''}/>
      <button className={getClass('es')} onClick={() => changeLanguage('es')}>
        ES
      </button>
    </div>
  );
};

export default Language;
